import React from 'react'
import PropTypes from 'prop-types'
import { Button, Flex } from '@leverege/ui-elements'
import { GeoPointCreator } from '@leverege/api-attributes'
import { GeoPointEditor } from '@leverege/ui-geo-elements'
import Util from './Util'

export default class GeoPointEditorWrapper extends React.Component {

  static TYPE = GeoPointCreator.typeName();

  static propTypes = {
    attribute : PropTypes.object,
    name : PropTypes.string,
    value : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.onChange = Util.onChange.bind( this )
    const { value } = props
    this.state = {
      value
    }
  }
  
  onChangeValue = ( { value } ) => {
    this.setState( { value } )
  }

  onSave = () => {
    const { value } = this.state
    this.onChange( value )
  }
  
  render() {
    const { attribute : attr } = this.props
    const { value } = this.state

    if ( attr == null ) {
      return <div />
    }
 
    return (
      <Flex direction="column" align="center">
        <GeoPointEditor value={value} onChange={this.onChangeValue} />
        <Button variant="link" style={{ marginLeft : 'auto', marginRight : 'auto' }} onClick={this.onSave}>Save</Button>
      </Flex>
    )
  }
}
